// components/CompetitionCard/CompetitionCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./CompetitonCard.scss";

const CompetitionCard = ({ title, imageUrl, description }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/competition-details');
  };

  return (
    <div 
      className="competition-card"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <div className="card-image-container">
        <img 
          src={imageUrl} 
          alt={title}
          className="card-image"
          loading="lazy"
        />
      </div>
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
        <div className="card-footer">
          <span className="read-more">Részletek →</span>
        </div>
      </div>
    </div>
  );
};

export default CompetitionCard;